<script setup lang="ts">
import QRious from 'qrious'
import { ref, watch, onMounted, defineProps } from 'vue'

const props = defineProps<{
    value: string
}>()

watch(
    () => props.value,
    (val) => qr.value.set({ value: '' + val })
)

const qr = ref(null)

onMounted(() => {
    qr.value = new QRious({
        element: document.getElementById('qrcode'),
        value: '' + props.value,
        size: 500,
        backgroundAlpha: 0,
    })
})
</script>

<template>
    <canvas id="qrcode"></canvas>
</template>
